export default __webpack_public_path__ + "static/media/dreamstime_s_36310251.7ff7e57f.jpg";